<template>
  <div v-if="readyRender" class="sidebar-flex-wrapper">
    <div id="logo" style="width: max-content !important;">
      <a class="noLinkColor" href="/"><img :src="logo" alt="Logo" style="max-width: 200px; max-height: 200px;"></a>
    </div>
    <div v-if="modeBadge" class="mode-badge-row">
      <span class="mode-badge" :class="'mode-badge--' + modeBadge.kind">{{ modeBadge.label }}</span>
    </div>
    <md-list class="pt-40 ml-20 sidebar-menu-list">
      <!-- <md-list-item v-if="parseInt(options.user.role) !== 0" @click="options.showImportTripForm = true"
                    class="padding-child-6-8 side_nav_el testi2">
        <md-icon class="testi" title="Neuen Vorgang importieren">loop</md-icon>
        <span class="md-list-item-text">{{options.Lang.Neuen_Vorgang_importieren}}</span>
      </md-list-item> -->

     

      <md-list-item to="/trips"
                    :class="options.currentRoute === 'Trips' || options.isTrips ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <!-- <span class="md-icon icon-travel_explore_FILL0_wght400_GRAD0_opsz48" title="Vorgänge"></span> -->
        <md-icon class="testi">travel_explore</md-icon>
        <span class="md-list-item-text">{{options.Lang.Vorgänge}}</span>
      </md-list-item>
      <md-list-item to="/trips" :class="options.currentRoute === 'Trips' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isTrips">
        <md-icon class="icon_double" title="Aktive Mandanten">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Aktive_Vorgänge}}</span>
      </md-list-item>
      <md-list-item to="/trips_archived" :class="options.currentRoute === 'TripsArchived' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isTrips">
        <md-icon class="icon_double" title="Aktive Mandanten">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Archivierte_Vorgänge}}</span>
      </md-list-item>
      <md-list-item  v-if="parseInt(options.user.role) !== 0" to="/suppliers"
                    :class="options.currentRoute === 'Suppliers' || options.isSuppliers ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon class="testi">label_important</md-icon>
        <span class="md-list-item-text">{{options.Lang.Suppliers}}</span>
      </md-list-item>
      <md-list-item to="/suppliers" :class="options.currentRoute === 'Suppliers' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isSuppliers">
        <md-icon class="icon_double" title="Aktive Suppliers">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Aktive_Suppliers}}</span>
      </md-list-item>
      <md-list-item to="/suppliers_archived" :class="options.currentRoute === 'SuppliersArchived' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isSuppliers">
        <md-icon class="icon_double" title="Aktive Suppliers">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Archivierte_Suppliers}}</span>
      </md-list-item>

      <md-list-item v-if="parseInt(options.user.role) !== 0" to="/users"
                    :class="options.currentRoute === 'Users' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Mandanten">people</md-icon>
        <span class="md-list-item-text">{{options.Lang.Benutzer}}</span>
      </md-list-item>
      <!--  ToDO add the module activation    -->
      <md-list-item v-if="parseInt(options.user.role) !== 0 && options.ModulPassolution" to="/passolution"
                    :class="options.currentRoute === 'Passolution' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="passport">document_scanner</md-icon>
        <span class="md-list-item-text">{{options.Lang.Passolution || 'Passolution'}}</span>
      </md-list-item>

      <md-list-item v-if="parseInt(options.user.role) !== 0" to="/brandings"
                    :class="options.currentRoute === 'Brandings' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon class="icon_double">apartment</md-icon>
        <span class="md-list-item-text">{{options.Lang.Brandings}}</span>
      </md-list-item>

      <!-- Extra Features is shown only when at least one feature inside it is enabled.
           For now that's just the Checkout (invoice_checkout) module. -->
      <md-list-item v-if="parseInt(options.user.role) !== 0 && options.ModulInvoiceCheckout" to="/extra-features"
                    :class="options.currentRoute === 'ExtraFeatures' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon class="icon_double">extension</md-icon>
        <span class="md-list-item-text">{{(options.Lang && options.Lang.ExtraFeatures) || 'Extra Features'}}</span>
      </md-list-item>

      <md-list-item v-if="options.ModulCollections == true" to="/collections"
                    :class="options.currentRoute === 'Collections' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon class="icon_double">featured_play_list</md-icon>
        <span class="md-list-item-text">{{options.Lang.Collections}}</span>
      </md-list-item>

      <md-list-item v-if="hasPoiModule && parseInt(options.user.role) !== 0" to="/pois"
                    :class="options.currentRoute === 'POI' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon class="icon_double">place</md-icon>
        <span class="md-list-item-text">POI</span>
      </md-list-item>
      <!--///////////////-->
      <md-list-item v-if="parseInt(options.user.role) !== 0" to="/imgKat"
                    :class="options.currentRoute === 'imgKat' || options.currentRoute === 'imgVerwaltung'  ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Titelbilder">gradient</md-icon>
        <span class="md-list-item-text">{{options.Lang.Titelbilder}}</span>
      </md-list-item>
      <md-list-item to="/imgKat" :class="options.currentRoute === 'imgKat' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isTitelbilder">
        <md-icon class="icon_double" title="Titelbilder">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Kategorien}}</span>
      </md-list-item>
      <md-list-item to="/imgVerwaltung" :class="options.currentRoute === 'imgVerwaltung' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isTitelbilder">
        <md-icon class="icon_double" title="Titelbilderverwaltung">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Verwaltung}}</span>
      </md-list-item>
      <!--///////////////-->
      
      <md-list-item v-if="parseInt(options.user.role) !== 0" to="/settings"
                    :class="options.currentRoute === 'Settings' || options.currentRoute === 'editPDF' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Settings">settings</md-icon>
        <span class="md-list-item-text">{{options.Lang.Einstellungen}}</span>
      </md-list-item>

      <md-list-item to="/settings" :class="options.currentRoute === 'Settings' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isSettings">
        <md-icon class="icon_double" title="Globale Einstellungen">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Einstellungen}}</span>
      </md-list-item>
      <md-list-item to="/editPDF" :class="options.currentRoute === 'editPDF' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="options.isSettings">
        <md-icon class="icon_double" title="Pdf Kategorien">chevron_right</md-icon>
        <span class="md-list-item-text">{{options.Lang.Pdf_Kategorien_bearbeiten}}</span>
      </md-list-item>

      <md-list-item v-if="parseInt(options.user.role) !== 0" to="/auswertung"
                    :class="options.currentRoute === 'Auswertung' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Auswertung">analytics</md-icon>
        <span class="md-list-item-text">{{options.Lang.Auswertung}}</span>
      </md-list-item>

      <md-list-item v-if="options.user.supersuper == 1 || options.user.supersuper == true" to="/modules"
                    :class="options.currentRoute === 'Modules' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Modules">extension</md-icon>
        <span class="md-list-item-text">{{options.Lang.Module}}</span>
      </md-list-item>

      <md-list-item v-if="options.user.supersuper == 1 || options.user.supersuper == true" to="/sendalert"
                    :class="options.currentRoute === 'SendAlert' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="SendAlert">feedback</md-icon>
        <span class="md-list-item-text">{{options.Lang.SendAlert}}</span>
      </md-list-item>
      <md-list-item v-if="options.user.supersuper == 1 || options.user.supersuper == true" to="/superadmin"
                    :class="options.currentRoute === 'SuperAdmin' ? 'active' : ''" class="padding-child-6-8 side_nav_el testi">
        <md-icon title="Super Admin">admin_panel_settings</md-icon>
        <span class="md-list-item-text">Super Admin</span>
      </md-list-item>

<!--      <md-list-item to="/clients" :class="options.currentRoute === 'Clients' ? 'active' : ''"
                    class="md-inset sublist_item" v-if="this.options.isClients">
        <md-icon class="icon_double" title="Aktive Mandanten">chevron_right</md-icon>
        <span class="md-list-item-text">Aktive Mandanten</span>
      </md-list-item>-->
    </md-list>
    <div id="user_menu_wrapper" style="padding-left: 0 !important;" class="w-100">
      <div class="user_menu" style="display: flex;">
        <md-button style="width: 65% !important; display: flex !important;" class="user_top_link" @click="changePW"><i v-if="options.user.pic" class="userPic"
                                            :style="'background-image: url('+ options.user.pic +');'"></i><span
            class="inline_block left"><span
            class="bold">{{ options.user.firstname + ' ' + options.user.lastname }}</span><br/><span>{{options.Lang.Einstellungen}}</span></span>
        </md-button>
        <md-button style="min-width: unset !important; width: 23%; display: flex; justify-content: center; align-items: center;" class="user_top_link" @click="showAlert">
  <md-icon style="margin-left: 0.3rem !important;" class="inline_block mt-7">warning</md-icon>
</md-button>

        <md-button style="min-width: unset !important; width: 22% " class="user_top_link" @click="logout">
          <md-icon style="margin-left: 0.3rem !important;" class="inline_block  mt-7">logout</md-icon>
        </md-button>
      </div>
      <br>
      <div class="top-border-line buttons-row">
        <div class="nav-button-group">
          <button class="support-btn">
            <a :href="`mailto:support@viavio.travel?subject=Support for ${companyName}`">Support</a>
          </button>

          <button class="version-btn" disabled>
            Version: {{ version }}
          </button>
        </div>

      </div>


    </div>
    

    <changePW @updateData="getAll()" v-if="options.showchangePW && options.user.loggedIn"
                :currentTrip="options.currentTrip" :options="options"></changePW>


                
  </div>
 
</template>

<script>
import changePW from "@/components/dialogs/changePW";

export default {
  name: 'BackendNaviContent',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    changePW
  },
  data() {
    return {
      companyName: process.env.VUE_APP_COMPANY || "No Company", // Loads Bitskin
      showAlertBox: false,
      alertMessage:[],
      readyRender: false,
      logo: null,
      version: null,
    }
  },
  computed: {
    hasPoiModule () {
      const mods = this.options && this.options.modules ? this.options.modules : [];
      return mods.find(m => m.name === 'poi' && m.status);
    },
    // Read live from the shared GlobalSettings so the badge updates the moment
    // SuperAdmin flips the toggle (it writes back into options.GlobalSettings).
    // Debug and Preview are mutually exclusive on the server; debug wins if
    // both are somehow stuck on.
    modeBadge () {
      const g = this.options && this.options.GlobalSettings || {};
      const truthy = (v) => v === 1 || v === '1' || v === true;
      if (truthy(g.nezasa_debug_mode)) return { kind: 'debug', label: 'DEBUG' };
      if (truthy(g.preview_mode)) return { kind: 'preview', label: 'PREVIEW' };
      return null;
    }
  },
  async created() {
    this.version = process.env.VUE_APP_VERSION
  },
  mounted() {
    let self = this;
    self.readyRender = false;
    self.options.user.supersuper = self.$store.getters.getUser.supersuper
        this.doPost({},'getglobalinfo', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          self.logo = result.baseLogo;
          // Mirror the latest values into the shared GlobalSettings so the
          // badge tracks the toggle even if App.vue hasn't refetched yet.
          if (self.options) {
            self.options.GlobalSettings = Object.assign({}, self.options.GlobalSettings || {}, result);
          }
          self.readyRender = true;
        }
      });
  },
  methods: {
    updateSeeAlertStatus(){
      this.showAlertBox = false;
    },
    async showAlert(){
      await this.getAlertMessage();
    },
    async getAlertMessage(){
      let self = this;
      //////////////////////////////////////////////////////////////////////////
      await this.doPost({}, 'getAlertMessage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          if(res?.data?.data[0]){
            let result = res.data.data[0]
            self.options.alertMessage = result
            // console.log(self.options.alertMessage, "alertbox")
          }else{
            self.options.alertMessage.nachricht = "Zurzeit gibt es keine aktuellen Hinweise oder Warnungen zum System."
          }
         
        }
      });
      self.options.showAlertBox = true;
    },
    changePW(){
      this.options.showchangePW = true;
    }
  }
}
</script>
<style>
.mode-badge-row {
  display: flex;
  justify-content: center;
  margin: 8px 0 4px;
  padding: 0 12px;
}

.mode-badge {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

.mode-badge--debug {
  background: #d32f2f;
}

.mode-badge--preview {
  background: #2e7d32;
}

.testi2{
  margin-top: 5px !important;
  margin-bottom: 20px !important;
}

.md-button-content{
  display: flex;
}

.testi2 button{
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  height: 100% !important;
}

li.md-list-item.padding-child-6-8.side_nav_el.testi{
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

li.md-list-item.padding-child-6-8.side_nav_el.testi a {
 margin-top: 0 !important;
 margin-bottom: 0 !important;
}

#alertBox{
    position: absolute;
    min-height: 10%;
    max-height: 80%;
    height: auto;
    width: 60%;
    top: 25%;
    left: 15%;
    background-color: white !important;
    z-index: +111111111;
  }
.top-border-line{
    border-top: 1px solid #d3d3d3;
    width: 80%;
    margin: auto;
    padding-top: 0.5rem;
}
.buttons-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  margin-top: -0.5rem;
}

.support-btn {
  font-size: 12px;
  padding: 6px 18px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 10px;
  cursor: pointer;
}

.support-btn a {
  text-decoration: none;
  color: #000 !important;
}

.version-btn {
  font-size: 10px;
  padding: 10px 12px;
  background: #f1f3f6;
  border: none;
  border-radius: 5px;
  color: #7a7a7a;
  cursor: not-allowed;
  opacity: 1; /* keep readable */
}
.nav-button-group{
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
}
.sidebar-flex-wrapper {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
}

.sidebar-menu-list {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  max-height: none !important;
}

#user_menu_wrapper {
  flex-shrink: 0 !important;
  position: static !important;
  padding-bottom: 10px !important;
}
</style>
